<ng-template #caretIcon>
  <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M9 6l6 6-6 6z"/></svg>
</ng-template>

<ng-template #folderIcon>
  <svg class="fm-ico" height="16" viewBox="0 0 40 32">
    <path d="M3 9a3 3 0 0 1 3-3h7l3 3h18a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z" fill="#5a91c4"/>
    <path d="M3 13h34v1.4H3z" fill="#3f79ac" opacity=".45"/>
  </svg>
</ng-template>

<ng-template #fileIcon>
  <svg class="fm-ico" height="17" viewBox="0 0 32 40">
    <path d="M7 1h12l8 8v28a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2z" fill="#fff" stroke="#c2c9d1" stroke-width="1.4"/>
    <path d="M19 1v6a2 2 0 0 0 2 2h6" fill="#eef1f4" stroke="#c2c9d1" stroke-width="1.4"/>
    <rect x="4" y="21" width="24" height="11" rx="2" fill="#56616c"/>
    <text x="16" y="29.3" text-anchor="middle" fill="#fff" font-size="8" font-weight="700">YML</text>
  </svg>
</ng-template>

<ng-template #eyeIcon>
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
    <path d="M1.8 12S5.6 5.5 12 5.5 22.2 12 22.2 12 18.4 18.5 12 18.5 1.8 12 1.8 12z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
</ng-template>

<ng-template #eyeHiddenIcon>
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
    <path d="M1.8 12S5.6 5.5 12 5.5c1.7 0 3.2.4 4.4 1M22.2 12s-3.8 6.5-10.2 6.5c-1.7 0-3.2-.4-4.4-1"/>
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/>
    <path d="M3.5 3.5l17 17"/>
  </svg>
</ng-template>

<!-- Templates of the combobox used to add resources and apps groups to an apps group -->
<ng-template #resourceBadge let-item="item">
  <span [attr.class]="'badge ' + resourceBadgeClass(item?.isAppsGroup ? 'apps group' : item?.resourceType)">
    {{ item?.isAppsGroup ? 'apps group' : item?.resourceType }}
  </span>
</ng-template>

<ng-template #templateSelectedResources let-item="item">
  <ng-container *ngTemplateOutlet="resourceBadge; context: {item: item}"></ng-container>
  {{ item?.name }}
</ng-template>

<ng-template #templateDisplayResources let-item='item'>
  <ng-container *ngTemplateOutlet="resourceBadge; context: {item: item}"></ng-container>
  {{ item.name }}<span class="fm-note" *ngIf="item.address && item.address != item.name">{{ item.address }}</span>
</ng-template>

<ng-template #templateDisplayResourcesWhenErrors>
  <clr-control-error slot="displayWhenError">There was an error</clr-control-error>
</ng-template>

@if (open) {
  <div class="agp-stack">

    <!-- ============================================================ Files -->
    <div class="agp-card" [class.expanded]="filesExpanded">

      <div class="agp-card-header" (click)="filesExpanded = !filesExpanded">
        <span class="fm-caret" [class.open]="filesExpanded">
          <ng-container *ngTemplateOutlet="caretIcon"></ng-container>
        </span>
        <ng-container *ngTemplateOutlet="folderIcon"></ng-container>
        <span class="agp-title">Apps groups files</span>
        <span class="fm-note">{{ generatedFiles.length + customFiles.length }} files</span>
        <span class="agp-spinner" *ngIf="isLoadingFiles">
          <clr-spinner [clrSmall]="true">Loading ...</clr-spinner>
        </span>
      </div>

      @if (filesExpanded) {
        <div class="agp-card-body">

          @if (filesFailureMode) {
            <div class="fm-msg error">Cannot load the apps groups files from DC Netscope API.</div>
          }

          <div class="fm-row" (click)="generatedExpanded = !generatedExpanded">
            <span class="fm-caret" [class.open]="generatedExpanded">
              <ng-container *ngTemplateOutlet="caretIcon"></ng-container>
            </span>
            <ng-container *ngTemplateOutlet="folderIcon"></ng-container>
            <span class="fm-name">Generated</span>
            <span class="fm-note">by DC Netscope</span>
          </div>

          @if (generatedExpanded) {
            <div class="fm-children">
              @for (file of generatedFiles; track file) {
                <div class="fm-row" [class.active]="file == selectedFile" (click)="selectFile(file)">
                  <span class="fm-caret leaf"></span>
                  <ng-container *ngTemplateOutlet="fileIcon"></ng-container>
                  <span class="fm-name">{{ file }}<span class="fm-ext">.yml</span></span>
                </div>
              }

              @if (generatedFiles.length == 0) {
                <div class="fm-empty">No generated file yet</div>
              }
            </div>
          }

          <div class="fm-row" (click)="customExpanded = !customExpanded">
            <span class="fm-caret" [class.open]="customExpanded">
              <ng-container *ngTemplateOutlet="caretIcon"></ng-container>
            </span>
            <ng-container *ngTemplateOutlet="folderIcon"></ng-container>
            <span class="fm-name">Custom</span>
            <span class="fm-note">{{ customFiles.length }}</span>
          </div>

          @if (customExpanded) {
            <div class="fm-children">
              @for (file of customFiles; track file) {
                <div class="fm-row" [class.active]="file == selectedFile" (click)="selectFile(file)">
                  <span class="fm-caret leaf"></span>
                  <ng-container *ngTemplateOutlet="fileIcon"></ng-container>
                  <span class="fm-name">{{ file }}<span class="fm-ext">.yml</span></span>
                  <span class="fm-act">
                    <span class="fm-icon-btn" title="Delete this file" (click)="$event.stopPropagation(); askToDeleteFile(file)">
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
                        <path d="M4 7h16M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2M6 7l1 13h10l1-13"/>
                      </svg>
                    </span>
                  </span>
                </div>
              }

              @if (customFiles.length == 0) {
                <div class="fm-empty">No custom file yet</div>
              }
            </div>
          }
        </div>

        <div class="agp-card-footer">
          <input class="fm-input" type="text" name="newFileName" autocomplete="off"
                 placeholder="new apps groups file"
                 [(ngModel)]="newFileName"
                 (keyup.enter)="createFile()"/>

          <button class="fm-btn primary" (click)="createFile()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            New file
          </button>
        </div>

        @if (!newFileNameIsValid) {
          <div class="agp-card-footer">
            <div class="fm-msg error">Invalid file name: only letters, digits, '_' and '-' are allowed.</div>
          </div>
        }
      }
    </div>

    <!-- =========================================================== Groups -->
    <!-- The edition accordion only shows up once a file is selected: it is dedicated to its apps groups -->
    @if (selectedFile != undefined) {
      <div class="agp-card" [class.expanded]="groupsExpanded">

        <div class="agp-card-header" (click)="groupsExpanded = !groupsExpanded">
          <span class="fm-caret" [class.open]="groupsExpanded">
            <ng-container *ngTemplateOutlet="caretIcon"></ng-container>
          </span>
          <ng-container *ngTemplateOutlet="fileIcon"></ng-container>
          <span class="agp-title">Apps groups of {{ selectedFile }}<span class="fm-ext">.yml</span></span>
          @if (isReadOnlyFile()) {
            <span class="badge badge-gray" title="This file is built by DC Netscope">read only</span>
          }
          <span class="fm-note">{{ appGroups.length }} groups</span>
          <span class="agp-spinner" *ngIf="isLoadingGroups || isPushing">
            <clr-spinner [clrSmall]="true">Loading ...</clr-spinner>
          </span>
        </div>

        @if (groupsExpanded) {
          <div class="agp-card-body">

            @if (groupsFailureMode) {
              <div class="fm-msg error">Cannot load the apps groups from DC Netscope API.</div>
            }

            @if (isReadOnlyFile()) {
              <div class="fm-msg">
                DC Netscope builds this file itself and rewrites it as it refreshes the infrastructure: its
                apps groups cannot be edited here. Display choices still apply, and a custom file can include
                these apps groups to build on them.
              </div>
            }

            @for (appGroup of appGroups; track appGroup) {
              <div class="fm-row ag-row" [class.active]="isGroupExpanded(appGroup)" [class.hidden-group]="isHidden(appGroup)">
                <span class="fm-caret" [class.open]="isGroupExpanded(appGroup)" (click)="toggleGroup(appGroup)">
                  <ng-container *ngTemplateOutlet="caretIcon"></ng-container>
                </span>

                <span class="ag-eye" [class.off]="isHidden(appGroup)"
                      [title]="isHidden(appGroup) ? 'Show this apps group' : 'Hide this apps group'"
                      (click)="$event.stopPropagation(); toggleHidden(appGroup)">
                  @if (isHidden(appGroup)) {
                    <ng-container *ngTemplateOutlet="eyeHiddenIcon"></ng-container>
                  } @else {
                    <ng-container *ngTemplateOutlet="eyeIcon"></ng-container>
                  }
                </span>

                <!-- The name of an expanded group is edited in place -->
                @if (isGroupExpanded(appGroup) && isEditable(appGroup)) {
                  <input class="ag-name" type="text" name="name-{{ $index }}" spellcheck="false"
                         aria-label="Apps group name"
                         [class.invalid]="appGroup.nameIsValid != undefined && !appGroup.nameIsValid"
                         [(ngModel)]="appGroup.name"
                         (ngModelChange)="appGroupNameChanged(appGroup)"/>
                } @else {
                  <span class="fm-name" (click)="toggleGroup(appGroup)">{{ appGroup.name }}</span>
                }
                <span class="ag-count">{{ ownMembersCount(appGroup) }}</span>

                <select class="ag-select" name="mode-{{ $index }}"
                        [disabled]="isHidden(appGroup)"
                        [ngModel]="getMode(appGroup)"
                        (ngModelChange)="setMode(appGroup, $event)"
                        (click)="$event.stopPropagation()">
                  <option value="summarized" title="Everything is folded into the apps group">Summarized</option>
                  <option value="sub_groups" [disabled]="(appGroup.included_apps_groups ?? []).length == 0"
                          title="The apps groups included in this one are shown as boxes, the members stay folded">Show sub-groups</option>
                  <option value="servers" title="Members exposing a port to another apps group">Show exposing ports</option>
                  <option value="servers_and_clients" title="Members exchanging flows with another apps group">Show active</option>
                  <option value="all" title="Every member, including those that exchanged nothing">Show all members</option>
                  <option value="all_traffic" title="Every member, and the flows inside the apps group drawn as well">Show all traffic (inside + outside)</option>
                </select>

                <!-- Settings that are seldom changed stay out of the way, in a menu -->
                <span class="ag-menu">
                  <button type="button" class="ag-icon-btn" title="More" aria-haspopup="true"
                          [attr.aria-expanded]="menuGroup === appGroup"
                          (click)="$event.stopPropagation(); toggleMenu(appGroup)">&#8942;</button>

                  @if (menuGroup === appGroup) {
                    <div class="ag-menu-list" (click)="$event.stopPropagation()">
                      <label title="Draw the flows exchanged between the members of this apps group. They are hidden by default, as a group usually talks to itself a lot. The members they link are the ones shown by the display mode of the group.">
                        <input type="checkbox" name="internal-flows-{{ $index }}"
                               [checked]="showsInternalFlows(appGroup)"
                               (change)="toggleInternalFlows(appGroup)"/>
                        Show flows inside this apps group
                      </label>

                      @if (isEditable(appGroup)) {
                        <div class="ag-menu-sep"></div>
                        <button type="button" class="danger" (click)="menuGroup = undefined; deleteAppGroup(appGroup)">
                          Delete this apps group
                        </button>
                      }
                    </div>
                  }
                </span>
              </div>

              @if (isGroupExpanded(appGroup)) {
                <div class="ag-content">

                  @if (appGroup.nameIsValid != undefined && !appGroup.nameIsValid) {
                    <div class="fm-msg error ag-name-error">Invalid name: only letters, digits and '_' are allowed.</div>
                  }

                  <!-- One field holds everything the group is made of: the included apps groups, the picked
                       members and the members matched by name. Clicking a chip shows or folds it in the view. -->
                  <div class="ag-tokens"
                       [class.readonly]="!isEditable(appGroup)"
                       [title]="isEditable(appGroup) ? 'Type the name of a VM, a host, an apps group, an IP address or a network (192.168.10.0/24)' : ''">

                    @for (included of appGroup.included_apps_groups ?? []; track includedLabel(included)) {
                      <span class="ag-chip group"
                            [class.missing]="includedIsMissing(included)"
                            [class.shown]="!includedIsMissing(included) && isIncludedVisible(appGroup, included)"
                            [title]="includedIsMissing(included)
                                     ? 'This apps group was not found in ' + includedFile(included) + ': it brings no member'
                                     : (isIncludedVisible(appGroup, included)
                                        ? 'Fold ' + includedLabel(included) + ' into this apps group'
                                        : 'Show ' + includedLabel(included) + ' as a box of its own inside this apps group')"
                            (click)="toggleIncludedVisibility(appGroup, included)">
                        <span class="ag-kind">group</span>
                        <span class="ag-chip-name">{{ includedLabel(included) }}</span>
                        @if (isEditable(appGroup)) {
                          <button type="button" class="ag-chip-x" title="Stop including this apps group"
                                  (click)="$event.stopPropagation(); removeIncludedAppGroup(appGroup, included)">&times;</button>
                        }
                      </span>
                    }

                    @for (vm of appGroup.vms; track vm.uuid) {
                      <span class="ag-chip" [class.shown]="isVmVisible(appGroup, vm)"
                            [title]="(isVmVisible(appGroup, vm) ? 'Fold this member into its apps group' : 'Show this member as a node of its own')
                                     + (hasNoFlow(vm) ? ' (this member took part in no flow)' : '')"
                            (click)="toggleVmVisibility(appGroup, vm)">
                        <!-- Most members are VMs: only the other kinds are named, so that they stand out -->
                        @if (memberType(vm.uuid) != 'vm') {
                          <span class="ag-kind">{{ memberType(vm.uuid) }}</span>
                        }
                        <span class="ag-chip-name">{{ vm.name }}</span>
                        @if (isEditable(appGroup)) {
                          <button type="button" class="ag-chip-x" title="Remove this member from the apps group"
                                  (click)="$event.stopPropagation(); deleteVmFromAppGroup(appGroup, vm)">&times;</button>
                        }
                      </span>
                    }

                    <!-- Members matched by the rules: removing one here would not last, the rules would match it
                         again, it is excluded from them instead -->
                    @for (vm of matchedOnlyMembers(appGroup); track vm.uuid) {
                      <span class="ag-chip matched" [class.shown]="isVmVisible(appGroup, vm)"
                            [title]="(isVmVisible(appGroup, vm) ? 'Fold this member into its apps group' : 'Show this member as a node of its own')
                                     + (hasNoFlow(vm) ? ' (this member took part in no flow)' : '')
                                     + '. Its name matches the patterns of the apps group.'"
                            (click)="toggleVmVisibility(appGroup, vm)">
                        @if (memberType(vm.uuid) != 'vm') {
                          <span class="ag-kind">{{ memberType(vm.uuid) }}</span>
                        }
                        <span class="ag-chip-name">{{ vm.name }}</span>
                        @if (isEditable(appGroup)) {
                          <button type="button" class="ag-chip-x" title="Exclude this member from the patterns"
                                  (click)="$event.stopPropagation(); excludeMatchedMember(appGroup, vm)">&#8856;</button>
                        }
                      </span>
                    }

                    @if (isEditable(appGroup)) {
                      <app-apps-groups-combobox
                        class="ag-add"
                        [(selectedItems)]="appGroup.selectedResources"
                        [itemsGenerator]="fetchResources(appGroup)"
                        (onChange)="vmSelectionChanged(appGroup, $event)"
                        [templateSelectedItems]="templateSelectedResources"
                        [templateDisplayItems]="templateDisplayResources"
                        [templateDisplayWhenErrors]="templateDisplayResourcesWhenErrors"
                        [itemsField]="'name'"
                        [placeholder]="'Add a VM, host, IP or group…'"
                      >
                      </app-apps-groups-combobox>
                    } @else if (ownMembersCount(appGroup) == 0 && (appGroup.included_apps_groups ?? []).length == 0) {
                      <span class="fm-empty">No VM in this apps group</span>
                    }
                  </div>

                  @if (ownMembersCount(appGroup) > 0 || (appGroup.included_apps_groups ?? []).length > 0) {
                    <div class="ag-legend">
                      @if (matchedOnlyMembers(appGroup).length > 0) {
                        <span><span class="ag-legend-dash"></span>matched by name</span>
                      }
                      <span>filled = shown in the view</span>
                    </div>
                  }

                  <!-- Members picked by their names: the appliance keeps the matched ones up to date as the
                       inventory changes, and computes them when the file is saved -->
                  @if (isEditable(appGroup)) {
                    <div class="ag-rules">
                      <div class="ag-rules-head" (click)="toggleRules(appGroup)">
                        <span class="fm-caret" [class.open]="isRulesOpen(appGroup)">
                          <ng-container *ngTemplateOutlet="caretIcon"></ng-container>
                        </span>
                        <span class="ag-rules-title">
                          Match by name
                          @if (!hasMembersRules(appGroup)) {
                            <span class="ag-mute">(none)</span>
                          }
                        </span>
                        <span class="ag-info"
                              title="Glob patterns on the names of the VMs and hosts: '*' stands for any characters, '?' for a single one, and '[,]' for a comma. The whole name must match, whatever the case. The flows descriptions using this apps group will automatically cover the VMs and hosts created later whose names match.">i</span>

                        @if (hasIncludePatterns(appGroup)) {
                          <span class="ag-rel">
                            <button type="button" class="ag-match-count" [class.zero]="!matchCount(appGroup)"
                                    (click)="$event.stopPropagation(); togglePreview(appGroup)">
                              {{ matchCountLabel(appGroup) }}
                            </button>

                            @if (previewedGroup === appGroup) {
                              <div class="ag-popover" (click)="$event.stopPropagation()">
                                @for (member of previewedMembers(appGroup); track $index) {
                                  <div class="ag-popover-row">
                                    <span class="ag-chip-name">{{ member.name }}</span>
                                    <span class="ag-kind">{{ member.type }}</span>
                                  </div>
                                }
                                @if (previewedOthersCount(appGroup) > 0) {
                                  <div class="ag-popover-more">and {{ previewedOthersCount(appGroup) }} more</div>
                                }
                              </div>
                            }
                          </span>
                        }
                      </div>

                      @if (isRulesOpen(appGroup)) {
                        <div class="ag-rules-body">
                          <div class="ag-tokens" (click)="patternInput.focus()">
                            @for (pattern of appGroup.includePatterns ?? []; track pattern) {
                              <span class="ag-chip pattern include" title="Include pattern">
                                <span class="ag-chip-name">{{ pattern }}</span>
                                <button type="button" class="ag-chip-x" title="Remove this pattern"
                                        (click)="$event.stopPropagation(); removePattern(appGroup, 'include', pattern)">&times;</button>
                              </span>
                            }
                            @for (pattern of appGroup.excludePatterns ?? []; track pattern) {
                              <span class="ag-chip pattern exclude" title="Exclude pattern">
                                <span class="ag-chip-name">{{ pattern }}</span>
                                <button type="button" class="ag-chip-x" title="Remove this pattern"
                                        (click)="$event.stopPropagation(); removePattern(appGroup, 'exclude', pattern)">&times;</button>
                              </span>
                            }

                            <!-- The kind the typed pattern is added to. The buttons do not take the focus, or the
                                 pattern being typed would be added on blur under the former kind -->
                            <span class="ag-kind-toggle" role="group" aria-label="Kind of pattern">
                              <button type="button" class="include" [class.on]="patternKind(appGroup) == 'include'"
                                      (mousedown)="$event.preventDefault()"
                                      (click)="$event.stopPropagation(); setPatternKind(appGroup, 'include')">+ include</button>
                              <button type="button" class="exclude" [class.on]="patternKind(appGroup) == 'exclude'"
                                      (mousedown)="$event.preventDefault()"
                                      (click)="$event.stopPropagation(); setPatternKind(appGroup, 'exclude')">&minus; exclude</button>
                            </span>

                            <input #patternInput class="ag-token-input" type="text" name="pattern-{{ $index }}"
                                   spellcheck="false" autocomplete="off" aria-label="Add a pattern"
                                   [placeholder]="patternKind(appGroup) == 'include' ? 'web-*, db-??' : '*-test'"
                                   [(ngModel)]="appGroup.patternDraft"
                                   (keydown)="patternKeydown(appGroup, $event)"
                                   (blur)="commitPatternDraft(appGroup)"/>
                          </div>

                          @if (membersRulesError(appGroup); as rulesError) {
                            <div class="fm-msg error">{{ rulesError }}</div>
                          } @else if (hasExcludePatterns(appGroup) && !hasIncludePatterns(appGroup)) {
                            <div class="fm-msg error">Exclude patterns alone match nothing: add an include pattern.</div>
                          } @else if (appGroup.rulesPreview?.failed) {
                            <div class="fm-msg error">The matching VMs and hosts could not be fetched.</div>
                          } @else if (previewIsTruncated(appGroup)) {
                            <div class="fm-msg">Only some of the matches are listed above until the file is saved.</div>
                          } @else {
                            <div class="fm-msg">Comma or Enter adds a pattern, <code>[,]</code> matches a comma.</div>
                          }

                          @if (hasIncludePatterns(appGroup)) {
                            <div class="fm-msg warning">
                              Descriptions using this group will also cover future VMs and hosts matching these patterns.
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            }

            @if (!isLoadingGroups && appGroups.length == 0) {
              <div class="fm-empty">This apps groups file holds no apps group yet</div>
            }
          </div>

          <div class="agp-card-footer">
            @if (isEditableFile()) {
              <button class="fm-btn" (click)="addAppGroup()" [disabled]="appsGroupsData == undefined">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 5v14M5 12h14"/>
                </svg>
                New app group
              </button>
            }

            @if (saveFailed) {
              <span class="fm-msg error">The file could not be saved.</span>
            } @else {
              <span class="fm-msg">Display choices apply right away.</span>
            }

            @if (isEditableFile()) {
              <button class="fm-btn primary" (click)="save()" [disabled]="appsGroupsData == undefined || isPushing || !allRulesAreValid()">
                Save file
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
}

<clr-modal [(clrModalOpen)]="showDeleteFileModal" [clrModalClosable]="true" [clrModalSize]="'sm'">
  <h3 class="modal-title">Delete an apps groups file</h3>
  <div class="modal-body">
    <p>
      The file '{{ fileToDelete }}.yml' and all the apps groups it contains will be deleted. This cannot be undone.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="showDeleteFileModal = false">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="deleteFile()">Delete</button>
  </div>
</clr-modal>
